import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  FormButton,
  Flex,
} from '@shared/components';

import { ThirdProctorInformationFormField, ThirdProctorDocumentFormFields } from '../../components';

interface CreateThirdProctorFormProps {
  onClose: () => void;
}
export default function CreateThirdProctorForm(props: Readonly<CreateThirdProctorFormProps>) {
  const { onClose } = props;
  return (
    <>
      <DialogContent>
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
          <ThirdProctorInformationFormField />
          <ThirdProctorDocumentFormFields />
        </Flex>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
          ยกเลิก
        </Button>
        <FormButton label='บันทึก' size='large' />
      </DialogActions>
    </>
  );
}
